import React, { useEffect, useRef } from 'react';
import * as THREE from 'three';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const Canvas2 = () => {
  const figureRef = useRef();
  const cameraRef = useRef();
  const rendererRef = useRef();
  const rafRef = useRef();

  useEffect(() => {
    // Configuración inicial de Three.js
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    camera.position.set(0, 5, 10);
    cameraRef.current = camera;

    const renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setSize(window.innerWidth, window.innerHeight);
    rendererRef.current = renderer;
    document.getElementById('canvas-container').appendChild(renderer.domElement);

    // Crear figura 3D (ejemplo: icosaedro)
    const geometry = new THREE.IcosahedronGeometry(1, 1);
    const material = new THREE.MeshStandardMaterial({ 
      color: 0x00ff88,
      metalness: 0.7,
      roughness: 0.2
    });
    const figure = new THREE.Mesh(geometry, material);
    figureRef.current = figure;
    scene.add(figure);

    // Iluminación
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
    scene.add(ambientLight);
    
    const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
    directionalLight.position.set(5, 5, 5);
    scene.add(directionalLight);

    // Animación de curva y rotación
    const path = {
      curviness: 1.5,
      values: [
        { x: 0, y: 0, z: 0 },    // Punto inicial
        { x: 3, y: -2, z: 2 },   // Punto de control 1
        { x: -3, y: -4, z: -2 }, // Punto de control 2
        { x: 0, y: -8, z: 0 }    // Punto final
      ]
    };

    const scrollTween = gsap.to(figure.position, {
      duration: 1,
      ease: "none",
      bezier: {
        values: path.values,
        curviness: path.curviness
      },
      paused: true,
      onUpdate: () => {
        // Rotación proporcional al progreso
        figure.rotation.y = scrollTween.progress() * Math.PI * 2;
        figure.rotation.x = scrollTween.progress() * Math.PI;
        
        // Ajustar cámara para seguir la figura
        camera.position.y = 5 + (figure.position.y * 0.5);
        camera.lookAt(figure.position);
      }
    });

    // Configurar ScrollTrigger
    ScrollTrigger.create({
      trigger: "#contentSection",
      start: "top center",
      end: "bottom center",
      scrub: true,
      onUpdate: self => {
        scrollTween.progress(self.progress);
        
        // Efecto de velocidad de rotación
        figure.rotation.z = self.progress * Math.PI * 1.5;
      }
    });

    // Animación continua
    const animate = () => {
      rafRef.current = requestAnimationFrame(animate);
      renderer.render(scene, camera);
    };
    animate();

    // Manejo de resize
    const handleResize = () => {
      camera.aspect = window.innerWidth / window.innerHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(window.innerWidth, window.innerHeight);
    };
    window.addEventListener('resize', handleResize);

    // Limpieza
    return () => {
      window.removeEventListener('resize', handleResize);
      cancelAnimationFrame(rafRef.current);
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
      renderer.dispose();
      const container = document.getElementById('canvas-container');
      if (container) container.removeChild(renderer.domElement);
    };
  }, []);

  return <div id="canvas-container" className="fixed top-0 left-0 w-full h-screen pointer-events-none"></div>;
};

export default Canvas2;